<template>
  <div>
    <!-- Tab nav -->
    <div class="border-b border-gray-200 px-4 flex items-center gap-1">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        @click="activeTab = tab.id"
        type="button"
        class="text-sm py-2.5 px-3 -mb-px border-b-2 transition-colors"
        :class="activeTab === tab.id
          ? 'border-primary-500 text-primary-700 font-semibold'
          : 'border-transparent text-gray-500 hover:text-gray-700'"
      >
        {{ tab.label }}
      </button>
    </div>

    <EntityTagCoverage
      v-if="activeTab === 'tags'"
      :allEntities="allEntities"
      :tagGroups="tagGroups"
      :groupsMode="groupsMode"
      :infoTagLookup="infoTagLookup"
    />
    <EntityEngagementCoverage
      v-else-if="activeTab === 'engagement'"
      :allEntities="filteredEntities"
    />
    <EntityAttributionCoverage
      v-else-if="activeTab === 'attribution'"
      :allEntities="filteredEntities"
    />
  </div>
</template>

<script>
import EntityTagCoverage from './EntityTagCoverage.vue'
import EntityEngagementCoverage from './EntityEngagementCoverage.vue'
import EntityAttributionCoverage from './EntityAttributionCoverage.vue'

export default {
  name: 'EntityReporting',
  components: { EntityTagCoverage, EntityEngagementCoverage, EntityAttributionCoverage },
  props: {
    allEntities: { type: Array, required: true },
    filteredEntities: { type: Array, required: true },
    tagGroups: { type: Array, default: () => [] },
    groupsMode: { type: String, default: 'and' },
    infoTagLookup: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      activeTab: 'attribution',
      tabs: [
        { id: 'attribution', label: 'Attribution' },
        { id: 'engagement', label: 'Engagement' },
        { id: 'tags', label: 'Tags' }
      ]
    }
  }
}
</script>
